module.exports = __webpack_public_path__ + "static/media/bashamayim_hi_block.29c640e3.PNG";